import { useEffect, useState } from "react";

type Orientation = "portrait" | "landscape";

export const useOrientation = (): Orientation => {
  const getOrientation = (): Orientation =>
    window.matchMedia("(orientation: portrait)").matches
      ? "portrait"
      : "landscape";

  const [orientation, setOrientation] = useState<Orientation>(getOrientation());

  useEffect(() => {
    const portraitQuery = window.matchMedia("(orientation: portrait)");

    const handleChange = () => {
      const next = getOrientation();

      setOrientation((prev) => {
        if (prev === next) return prev; // ✅ CRITICAL FIX
        return next;
      });
    };

    portraitQuery.addEventListener("change", handleChange);

    return () => {
      portraitQuery.removeEventListener("change", handleChange);
    };
  }, []);

  return orientation;
};
